/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import styled from 'styled-components'
import is from 'styled-is'
import SlickSlider from 'react-slick'
import {IoIosArrowForward, IoIosArrowBack} from 'react-icons/io'
import {up, down} from 'styled-breakpoints'

import {colors} from '~/constants/style'
import {withInnerWrapper} from '~/hocs'

const Slider = styled(SlickSlider)`
  height: 100%;

  .slick-list {
    height: 100%;

    .slick-track {
      height: 100%;

      .slick-slide {
        > div {
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
  }
`

const AWItem = styled.div.attrs(
)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const Item = styled(
  withInnerWrapper(AWItem, 'bgSrc')('div'),
)`
  padding-top: 55%;
  position: relative;
  overflow: hidden;

  ${down('sm')} {
    padding-top: 110%;
  }
`

Item.Arrow = styled(
  ({
    next, prev, className, onClick,
  }) => (
    <div
      className={className}
      onClick={onClick}
      role='button'
      tabIndex='0'
    >
      {next && <IoIosArrowForward />}

      {prev && <IoIosArrowBack />}
    </div>
  ),
)`
  opacity: 1;
  position: absolute;
  width: 45px;
  height: 45px;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.25s;
  background: ${colors.green};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 1;

  > svg {
    font-size: 1.25rem;
  }

  &::before {
    content: none !important;
  }

  ${up('md')} {
    opacity: 0;

    ${Slider}:hover & {
      opacity: 1;
    }
  }

  &:hover {
    background: black;
    color: white;
  }

  ${is('next')`
    right: 0;
  `}

  ${is('prev')`
    left: 0
  `}
`

export {Slider, Item}
